import React from 'react'
import { Link } from 'react-router-dom'
import Field from '../common/FormField'
import styles from './common.module.css'

function ForgotPasswordForm({ onEmailChange, inProgress, error, onSubmit, sent }) {
  if (sent) {
    return (
      <div className={styles.successMessage}>
        <header>Check Your Email</header>
        <div className={styles.successBody}>
          <i className="fa fa-envelope-o" style={{ fontSize: 40, color: '#7b5ea7', marginBottom: 16, display: 'block' }} />
          <p>
            If an account with that email address exists, we have sent a password reset link to your inbox.
            Please check your email and follow the instructions.
          </p>
          <p className={styles.successNote}>
            Did not receive an email? Check your spam folder or{' '}
            <Link to="/forgot-password" onClick={onSubmit && (() => window.location.reload())}>
              try again
            </Link>.
          </p>
          <div className={styles.successActions}>
            <Link to="/login" className={`btn btn-primary ${styles.submitButton}`}>
              Back to Sign In
            </Link>
          </div>
        </div>
      </div>
    )
  }

  return (
    <form
      id="forgot-password-form"
      className="smart-form client-form"
      noValidate
      onSubmit={event => {
        event.preventDefault()
        onSubmit(event)
      }}
    >
      <header>Forgot Password</header>
      <fieldset>
        <div className={styles.intro}>
          Enter your email address and we will send you a link to reset your password.
        </div>

        {error && error.message && (
          <div className={styles.loginErrorMsg} role="alert">
            {error.message}
          </div>
        )}

        <Field type="input" name="Email" error={error.email}>
          <i className="icon-append fa fa-envelope" />
          <input
            type="text"
            name="email"
            placeholder="Enter your email"
            autoComplete="email"
            onChange={onEmailChange}
          />
        </Field>
      </fieldset>

      <footer className={styles.footer}>
        <button
          type="submit"
          className={`btn btn-primary ${styles.submitButton}`}
          disabled={inProgress}
        >
          {inProgress ? 'Sending...' : 'Send Reset Link'}
        </button>
        <div className={styles.footerLinks}>
          <Link to="/login">Back to Sign In</Link>
        </div>
      </footer>
    </form>
  )
}

export default ForgotPasswordForm
